// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fwgb","clinicsSelect":"styles_clinicsSelect__32gDe"};